import gql from 'graphql-tag';
import { parseToMutationRequest } from 'utils/utils';

export default data => {
  const dataModify = parseToMutationRequest(data, []);
  const modifyInvoiceDueDate = `modifyInvoiceDueDate(input: ${dataModify})`;
  return gql`
  mutation {
    ${modifyInvoiceDueDate} {
      id
    }
  }
`;
};
